import { get } from '../utils/makeRequest';

const PREVIOUS_CLOSE_ENDPOINTS = {
  GET_PREVIOUS_CLOSE: '/forex/previous-close',
  GET_AVAILABLE_SYMBOLS: '/forex/available-symbols',
};

export const previousCloseService = {
  /**
   * Get previous close data for a symbol with API key
   * @param {string} symbol - Currency pair symbol
   * @param {string} apiKey - User's API key
   * @returns {Promise} - Previous close data
   */
  getPreviousCloseData: async (symbol, apiKey) => {
    if (!symbol || !apiKey) {
      throw new Error('Symbol and API key are required');
    }
    
    const endpoint = `${PREVIOUS_CLOSE_ENDPOINTS.GET_PREVIOUS_CLOSE}?symbol=${encodeURIComponent(symbol)}&apiKey=${encodeURIComponent(apiKey)}`;
    return get(endpoint);
  },

  /**
   * Get available symbols with API key
   * @param {string} apiKey - User's API key
   * @returns {Promise} - Available symbols
   */
  getAvailableSymbols: async (apiKey) => {
    if (!apiKey) {
      throw new Error('API key is required');
    }
    
    const endpoint = `${PREVIOUS_CLOSE_ENDPOINTS.GET_AVAILABLE_SYMBOLS}?apiKey=${encodeURIComponent(apiKey)}`;
    return get(endpoint);
  },
};